import {createAction} from "redux-act";
import {IArticles, ICountry, IFanVoteRanking, IPlayer, ISettings, ISquad} from "modules/types";
import {IFetchJSONResponse} from "modules/reducers";

export const fetchPlayers = createAction();
export const fetchPlayersSuccess = createAction<IPlayer[]>();
export const fetchPlayersFailed = createAction();

export const fetchSquads = createAction();
export const fetchSquadsSuccess = createAction<ISquad[]>();
export const fetchSquadsFailed = createAction();

export const fetchSettings = createAction();
export const fetchSettingsSuccess = createAction<ISettings>();
export const fetchSettingsFailed = createAction();

export const fetchCountriesRequest = createAction();
export const fetchCountriesSuccess = createAction<ICountry[]>();

export const fetchHelpJSONs = createAction();
export const fetchHelpJSONsSuccess = createAction<IFetchJSONResponse>();

export const fetchFanVoteRankings = createAction();
export const fetchFanVoteRankingsSuccess = createAction<IFanVoteRanking[]>();
export const fetchFanVoteRankingsFailed = createAction();

export const fetchArticles = createAction();
export const fetchArticlesSuccess = createAction<IArticles>();
export const fetchArticlesFailed = createAction();
